import { authorizedGet } from '../utils/api';
import { STATISTIC_IFRAME_INFO } from '../constants/api';

class QuickSightService {
  static getIframeURLs = token => authorizedGet(STATISTIC_IFRAME_INFO, token);
}

export default QuickSightService;
